<template lang="pug">
el-collapse#card-dados-territorio(v-model='collapse')
    el-collapse-item.pb-0(name='item')
        header.p-2(slot='title')
            .esquerda
                span {{ index + 1 }}
                h3 {{ territorio.nome }}
                span.erro(v-if='$v.dados.$invalid') *

            .direita
                h3.mr-2.p-1 {{ territorio.localidade }}
                BaseButton.buttonLaudoDanger(
                    type='danger',
                    icon='el-icon-delete',
                    @click='$emit("removerTerritorio", territorio.id)'
                )

        el-form.form.p-2(label-position='top', size='small')
            .box
                .box-esquerda
                    el-form-item.produtor
                        .label(slot='label')
                            span {{ $t('laudos.produtor') }}
                            span(
                                v-show='this.territorio.representantes.length === 0'
                            ) - {{ $t('laudos.nenhumaPessoaVinculada') }}
                            span.erro(
                                v-if='$v.nomeRepresentante.$invalid && $v.cpfCnpjRepresentante.$invalid'
                            ) *
                        el-radio(
                            v-for='(representante, index) in territorio.representantes',
                            v-model='representanteSelecionado',
                            :label='index',
                            :key='representante.cpfCnpj'
                        )
                            | {{ representante.nomeRazaoSocial }} ({{ numeralStringFormatTocpfCnpj(representante.cpfCnpj) }})
                            span.espacoRepresentante

                        .outro
                            el-radio(
                                v-model='representanteSelecionado',
                                :label='outroRepresentante'
                            ) {{ $t('laudos.outro') }}:
                            .input(
                                v-if='representanteSelecionado == outroRepresentante'
                            )
                                el-input.nome(
                                    v-model='outro.nome',
                                    :placeholder='$t("laudos.insiraNomeOuRazaoSocialDaPessoa")'
                                )

                                el-input.cpfCnpj(
                                    v-model='outro.cpfCnpj',
                                    :placeholder='$t("laudos.documentoDaPessoa")',
                                    :class='{ "erro-borda": !cpfCnpjValido }',
                                    @change='aplicarMascara()'
                                )

                            .input(v-else)
                                el-input.nome(
                                    disabled,
                                    :placeholder='$t("laudos.insiraNomeOuRazaoSocialDaPessoa")'
                                )
                                el-input.cpfCnpj(
                                    disabled,
                                    :placeholder='$t("laudos.documentoDaPessoa")'
                                )

                    .dados
                        el-form-item
                            .label(slot='label')
                                span {{ $t('laudos.numeroDaOperacao') }}
                                span.erro(v-if='$v.numeroOperacao.$invalid')
                            el-input(v-model.lazy='numeroOperacao')

                        el-form-item
                            .label(slot='label')
                                span {{ $t('laudos.tipoDeEmpreendimento') }}
                                span.erro(
                                    v-if='$v.tipoEmpreendimento.$invalid'
                                )
                            el-input(v-model.lazy='tipoEmpreendimento')

                        el-form-item
                            .label(slot='label')
                                span {{ $t('laudos.dataReferenciaParaCriacaoLaudo') }}
                                span.erro(
                                    v-if='$v.dataReferenciaLaudo.$invalid'
                                ) *
                            el-date-picker(
                                v-model='dataReferenciaLaudo',
                                format='dd/MM/yyyy'
                            )
                .box-direita
                    el-form-item
                        el-upload.upload-demo(
                            action='#',
                            :auto-upload='false',
                            :on-change='onLoadFile',
                            :on-remove='onRemoveFile',
                            :before-upload='antesUploadArquivo',
                            :on-exceed='verificarLimite',
                            :before-remove='antesRemoverArquivo',
                            multiple,
                            :limit='3',
                            drag,
                            :file-list='fileList'
                        )
                            i.el-icon-upload(style='margin-top: 40px')
                            .el-upload__text {{ $t('laudos.arrasteParaSubir.1') }} <em>{{ $t('laudos.arrasteParaSubir.2') }}</em><br> {{ $t('laudos.arrasteParaSubir.3') }}
</template>

<script>
import formatters from '@/modules/laudos/utils/formatters';
import validators from '@/modules/laudos/utils/validators';
import { required } from 'vuelidate/lib/validators';
import TipoLaudo from '@/modules/laudos/constants/TipoLaudo';
import UploadHelp from '@/constants/UploadHelp';
import LaudosService from '@/modules/laudos/services/LaudosService';
import axios from 'axios';
import BaseButton from '@/modules/laudos/components/BaseButton.vue';

const OUTRO_REPRESENTANTE = '42';

export default {
    name: 'CardDadosTerritorioBenfeitorias',
    components: {
        BaseButton
    },
    emits: ['removerTerritorio', 'getDados', 'getValidacao'],

    props: {
        territorio: {
            type: Object,
            required: true
        },
        index: {
            type: Number,
            default: 0
        },
        valido: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            collapse: ['item'],
            representanteSelecionado: '',
            outro: {
                nome: '',
                cpfCnpj: ''
            },
            outroRepresentante: OUTRO_REPRESENTANTE,
            nomeRepresentante: '',
            cpfCnpjRepresentante: '',
            cpfCnpjValido: true,
            numeroOperacao: '',
            tipoEmpreendimento: '',
            dataReferenciaLaudo: null,
            arquivosUploads: [],
            fileList: []
        };
    },

    mounted() {
        if (this.territorio.representantes.length === 0) {
            this.representanteSelecionado = OUTRO_REPRESENTANTE;
        }
        this.$emit('getValidacao', {
            valido: !this.$v.dados.$invalid,
            id: this.territorio.id
        });
    },

    watch: {
        representanteSelecionado: function () {
            // eslint-disable-next-line eqeqeq
            if (this.representanteSelecionado != OUTRO_REPRESENTANTE) {
                this.nomeRepresentante =
                    this.territorio.representantes[
                        this.representanteSelecionado
                    ].nomeRazaoSocial;
                this.cpfCnpjRepresentante =
                    this.territorio.representantes[
                        this.representanteSelecionado
                    ].cpfCnpj;
            } else {
                this.nomeRepresentante = '';
                this.cpfCnpjRepresentante = '';
            }
        },

        'outro.nome': function () {
            this.nomeRepresentante = this.outro.nome;
        },

        'outro.cpfCnpj': function () {
            this.cpfCnpjValido = validators.validarDocumento(
                this.outro.cpfCnpj
            );

            if (this.cpfCnpjValido) {
                this.cpfCnpjRepresentante = this.outro.cpfCnpj;
            } else {
                this.cpfCnpjRepresentante = '';
            }
        },
        '$v.dados.$invalid': function () {
            this.emitDados();
        },
        numeroOperacao: function () {
            this.emitDados();
        },
        tipoEmpreendimento: function () {
            this.emitDados();
        }
    },

    validations: {
        nomeRepresentante: { required },
        cpfCnpjRepresentante: { required },
        numeroOperacao: {},
        tipoEmpreendimento: {},
        dataReferenciaLaudo: { required },
        dados: [
            'numeroOperacao',
            'tipoEmpreendimento',
            'dataReferenciaLaudo',
            'nomeRepresentante',
            'cpfCnpjRepresentante'
        ]
    },

    methods: {
        numeralStringFormatTocpfCnpj(value) {
            return formatters.numeralStringFormatToDocumento(value);
        },
        cpfCnpjFormatToNumeral(value) {
            return formatters.documentoFormatToNumeral(value);
        },
        async onLoadFile(file, fileList) {
            let url = process.env.VUE_APP_HTTP_PATH + '/laudo/upload-temp';
            let formData = new FormData();
            formData.append('file', file.raw);
            const { data, status } = await axios.post(url, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            if (status === 200) {
                const arq = { nomeArquivo: data, uid: file.uid };
                this.arquivosUploads.push(arq);
                this.emitDados();
            } else {
                this.$notify.error({
                    message: this.$t('laudos.erro.naoFoiPossivelEnviarArquivo')
                });
            }
        },
        async onRemoveFile(file, fileList) {
            const arqRemover = this.arquivosUploads.filter(
                a => a.uid === file.uid
            );
            const { status } = await LaudosService.removerArquivoTemp(
                arqRemover[0].nomeArquivo
            );
            if (status === 200) {
                this.arquivosUploads = this.arquivosUploads.filter(
                    l => l.uid !== file.uid
                );
                this.emitDados();
                return true;
            } else {
                this.$notify.warning({
                    message: this.$t('laudos.erro.naoFoiPossivelDeletarArquivo')
                });
                return false;
            }
        },
        verificarLimite() {
            this.$notify.warning({
                message: UploadHelp.MsgLimite(3)
            });
        },
        antesUploadArquivo(file) {
            if (file.size > UploadHelp.size) {
                return false;
            }
            return true;
        },
        async antesRemoverArquivo(file) {
            const result = await this.$messageBox.confirm(
                this.$t('laudos.desejaRemoverEsteArquivo'),
                this.$t('laudos.aviso'),
                {
                    confirmButtonText: this.$t('mensagens.comuns.sim'),
                    cancelButtonText: this.$t('mensagens.comuns.cancelar'),
                    type: 'warning'
                }
            );
            return result;
        },
        emitDados() {
            if (
                !this.dataReferenciaLaudo &&
                !this.nomeRepresentante &&
                !this.cpfCnpjRepresentante
            ) {
                return;
            }
            if (this.$v.$invalid) return;
            let arquivosUploadNomes = [];
            if (this.arquivosUploads.length > 0) {
                Object.keys(this.arquivosUploads).forEach(item => {
                    arquivosUploadNomes.push(
                        this.arquivosUploads[item].nomeArquivo
                    );
                });
            }

            this.$emit('getValidacao', {
                valido: !this.$v.dados.$invalid,
                id: this.territorio.id
            });
            this.$emit('getDados', {
                dados: {
                    nomeRepresentante: this.nomeRepresentante,
                    cpfCnpjRepresentante: this.cpfCnpjFormatToNumeral(
                        this.cpfCnpjRepresentante
                    ),
                    territorioId: this.territorio.id,
                    numeroOperacao: this.numeroOperacao,
                    tipoEmpreendimento: this.tipoEmpreendimento,
                    dataReferencia: this.dataReferenciaLaudo.toISOString(),
                    nomeArquivos: arquivosUploadNomes,
                    tipoLaudoId: TipoLaudo.BENFEITORIAS,
                    tipoDocumentoRepresentante:
                        this.cpfCnpjRepresentante.length < 11
                            ? 'RUC'
                            : 'CPF_CNPJ'
                },
                id: this.territorio.id
            });
        },

        aplicarMascara() {
            this.outro.cpfCnpj = formatters.documentoFormatToNumeral(
                this.outro.cpfCnpj
            );
            this.outro.cpfCnpj = formatters.numeralStringFormatToDocumento(
                this.outro.cpfCnpj
            );
        }
    }
};
</script>

<style lang="scss" scoped>
#card-dados-territorio {
    background-color: var(--white);
    border-radius: 4px;
    overflow: hidden;
    width: 100% !important;

    header {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 0 !important;

        .esquerda,
        .direita {
            display: flex;
            align-items: center;
            justify-content: space-between;

            gap: 4px;
        }

        .esquerda {
            span {
                color: var(--gray);
                font-size: 12px;
            }
        }

        .direita {
            h3 {
                background-color: var(--default-border-color);
                border-radius: 4px;
            }
        }
    }

    .form {
        .produtor .outro .input {
            display: flex;
            justify-content: space-between;

            .nome {
                width: 66%;
            }

            .cpfCnpj {
                width: 33%;
            }
        }

        .dados {
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            gap: 26px;
            width: 100% !important;

            .el-input,
            .el-select,
            .el-date-picker {
                width: 150px;
            }
        }

        .el-radio {
            min-width: 0px !important;
        }
    }
    .box {
        display: grid;
        grid-template-columns: auto 578px;
    }

    .upload-demo {
        padding: 10px;
    }

    @media (max-width: 1126px) {
        .box {
            display: flex;
            flex-wrap: wrap;
        }
    }
}

.el-collapse-item__arrow {
    width: 0px;
    color: var(--white);
}

.el-form-item__label {
    margin-bottom: -10px;
}

.el-collapse-item__content {
    padding-bottom: 0px;
}

.erro {
    color: red !important;
}

.erro-borda {
    border-radius: 4px;
    border: 1px solid red;
}
.el-upload {
    flex: 1;
    .el-icon-upload {
        font-size: 40px;
        margin: 0px;
    }
}

.el-upload-dragger {
    width: 558px !important;
}
</style>
